import { AnyAction, ThunkAction } from '@reduxjs/toolkit';
import { StoreType } from '../../types/storeModels';
import MyEventService from '../../services/myEventService';
import { EventModel } from '../../types';
import { generateSearchParam } from '../utils';
import { RootState } from '../index';
import myEventSlice from './myEventSlice';

export const eventActions = myEventSlice.actions;

export const fetchAllMyEvents = (param: StoreType): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async dispatch => {
    const searchParam = generateSearchParam(param.searchParam);
    let response: any = await MyEventService.getMyEvent(param, searchParam);
    dispatch(eventActions.setMyEvents({ searchInput: param.searchParam, data: response.data }));
  };
};

export const clearMyEvents = (): ThunkAction<void, RootState, unknown, AnyAction> => {
  return dispatch => {
    dispatch(eventActions.clearMyEvents());
  };
};

export const clearMyEventsRegStatus = (): ThunkAction<void, RootState, unknown, AnyAction> => {
  return dispatch => {
    dispatch(eventActions.setRegistrationStatus({ status: false }));
  };
};

export const registerMyEvents = (event: EventModel): ThunkAction<void, RootState, unknown, AnyAction> => {
  return dispatch => {
    if (event._id) {
      MyEventService.registerEvent(event._id).then(res => {
        console.log(res);
        dispatch(eventActions.appendMyEvent({ data: { event: res.data.event } }));
        dispatch(eventActions.setRegistrationStatus({ status: true }));
      });
    }
  };
};
